<div class="teaching-staff-page">
  <app-header-style-seven></app-header-style-seven>

  <section class="page-shell teaching-staff-shell">
    <div class="custom-container">
      <div class="content-shell teaching-staff-content-shell">

        <!-- PAGE HERO -->


        <!-- STAFF DIRECTORY -->
        <section class="staff-section">
          <div class="staff-toolbar">
            <div class="user-actions">
              <i class="bx bx-user-voice"></i>
              <div>
                <span>Faculty Details 2026 - 2027</span>
                
              </div>
            </div>

       
          </div>

          <div class="table-card">
            <div class="table-card-header">
              <div>
                <h2>Teaching Faculty Directory</h2>
                <p>Department-wise faculty details</p>
              </div>
              
            </div>

            <div class="order-table table-responsive custom-staff-table">
              <table class="table table-bordered align-middle mb-0">
                <thead>
                  <tr>
                    <th class="col-sno">S.No</th>
                    <th class="col-aufin">AU-FIN</th>
                    <th class="col-aicte">AICTE ID</th>
                    <th class="col-name-designation">Name &amp; Designation</th>
                    <th class="col-photo">Photo</th>
                  </tr>
                </thead>

                <tbody>
                  <ng-container
                    *ngFor="let staff of facultyList; let i = index; trackBy: trackBySno"
                  >
                    <tr *ngIf="showDepartmentHeader(i)" class="department-row">
                      <td colspan="5">{{ staff.department }}</td>
                    </tr>

                    <tr class="faculty-row">
                      <td class="col-sno">{{ staff.sno }}</td>
                      <td class="aufin-value">{{ staff.auFin }}</td>
                      <td class="aicte-value">{{ staff.aicteId || '—' }}</td>
                      <td class="name-designation">{{ staff.nameDesignation }}</td>
                      <td class="photo-cell">
                        <img
                          class="faculty-photo"
                          [src]="staff.photoPath"
                          [alt]="staff.nameDesignation"
                          loading="lazy"
                        />
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </section>

      </div>
    </div>
  </section>
</div>
